import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import AOS from 'aos';
import 'aos/dist/aos.css';

import './Home';
import './Comercializacion.css';
import ImagenComer from '../assets/images/FLO1.png';
import IM1 from '../assets/images/IM1.jpg';
import IM2 from '../assets/images/IM2.jpg';
import IM3 from '../assets/images/IM3.jpg';
import IM4 from '../assets/images/IM4.jpg';
import IM5 from '../assets/images/IM5.jpg';
import IM6 from '../assets/images/IM6.webp';
import IM7 from '../assets/images/IM7.webp';
import IM8 from '../assets/images/IM8.png';
import IM9 from '../assets/images/IM9.webp';
import IM10 from '../assets/images/IM10.webp';
import IM11 from '../assets/images/IM11.jpg';
import IM12 from '../assets/images/IM12.png';
import IM13 from '../assets/images/IM13.webp';
import IM14 from '../assets/images/IM14.jpg';
import IM15 from '../assets/images/IM15.webp';
import IM16 from '../assets/images/IM16.jpg';
import IM17 from '../assets/images/IM17.webp';
import IM18 from '../assets/images/IM18.webp';
import IM19 from '../assets/images/IM19.webp';
import IM20 from '../assets/images/IM20.png';
import IM21 from '../assets/images/IM21.png';
import IM22 from '../assets/images/IM22.webp';
import IM23 from '../assets/images/IM23.webp';
import IM24 from '../assets/images/IM24.jpg';
import IM25 from '../assets/images/IM25.png';
import IM26 from '../assets/images/IM26.webp';
import IM27 from '../assets/images/IM27.png';
import IM28 from '../assets/images/IM28.jpg';
import IM29 from '../assets/images/IM29.webp';
import IM30 from '../assets/images/IM30.png';
import IM31 from '../assets/images/IM31.jpg';
import IM32 from '../assets/images/IM32.webp';
import IM33 from '../assets/images/IM33.png';
import IM34 from '../assets/images/IM34.jpg';
import IM35 from '../assets/images/IM35.png';
import IM36 from '../assets/images/IM36.jpg';
import Facebok from '../assets/images/Facebok.png';
import Wasa from '../assets/images/Wasa.png';
import Wasa2 from '../assets/images/Wasa.png';
import insta from '../assets/images/insta.png';
import Compu from '../assets/images/Compu2.png';
import Peri from '../assets/images/Peri.jpg';
import Har from '../assets/images/Har.png';
import Redes from '../assets/images/switch.png'; // o la ruta que uses
import Disco from '../assets/images/Disco.png';
import Tonner from '../assets/images/tonner.png';
import ImagenBannerTI from '../assets/images/Banner12.jpg';
import Ubi from '../assets/images/Ubi.png';
import Telefono from '../assets/images/Telefono.png';
import Email34 from '../assets/images/Correo.png';
import checkAnim from '../assets/images/check.gif';
import RedesFondo from '../assets/images/Red-Neuronal.png';

function Comercializacion() {

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true, // animar solo una vez
    });
  }, []);

  const [enviado, setEnviado] = useState(false);
    
      const handleSubmit = (e) => {
        e.preventDefault();
        const form = e.target;
    
        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
        }).then(() => {
          setEnviado(true);
          form.reset();
          // Opcional: volver a mostrar formulario después de 5s
          // setTimeout(() => setEnviado(false), 5000);
        });
      };

  return (
    <>
     {/*Inicio Comercializacion*/}
<div className="infra-banner">
  {/* Imagen en la sección de inicio Infraestructura TI*/}
  <img src={ImagenBannerTI} alt="Infraestructura TI" className="banner-img" />
  {/*Titulo Infraestructura TI Sección Inicio  */}
    <h1 className="banner-texto">Infraestructura TI</h1>
</div>

{/*Bloque introducción Infraestructura TI */}
<div className="infra-descripcion">
  
  <p>
    {/*Descripción Sección Infraestructura TI */}
    Ofrecemos soluciones tecnológicas integrales a través de equipos de cómputo, periféricos, componentes de hardware, sistemas de almacenamiento, infraestructura de red y conectividad.<br></br> Cada propuesta está diseñada para adaptarse a las necesidades específicas de tu organización, asegurando eficiencia, confiabilidad y escalabilidad.<br></br>
     Respaldamos tu operación con productos de calidad, atención personalizada y asesoría técnica especializada que impulsa tu crecimiento.
  </p>
</div>


<div className="infra-tarjetas-contenedor">
  {/* Bloque Clasificaciones TI */}
  {[
    {
      //columna 1 Clasificación TI 
      //Titulo columna 1 Computación 
      title: 'Equipos de Computación',
      //Puntos columna 1 Computación 
      text: [
        'Laptops / notebooks',
        'PCs de escritorio',
        'All-in-one (Todo en uno)',
        'Ultrabooks',
        'Chromebooks'
      ],
      //Imagen columna 1 Computación
      img: Compu,
      //Route Catalogo Computación
      route: '/catalogo/Computadoras'
    },
    {
       //columna 2 Clasificación TI
       //Titulo columna 2 Perifericos 
      title: 'Periféricos y Accesorios',
      text: [
        //Puntos columna 2 Perifericos 
        'Teclados, mouse, monitores',
        'Impresoras, cámaras',
        'Auriculares, hubs USB',
        'Bases, soportes, conectores',
        'Proyectores y más'
      ],
      //Imagen columna 2 Perifericos
      img: Peri,
      //Route Catalogo Perifericos
      route: '/catalogo/Perifericos'
    },
    {
       //columna 3 Clasificación TI 
       // Titulo columna 3 hardware 
      title: 'Componentes de hardware',
      text: [
        // Puntos columna 3 hardware 
        'Procesadores (CPUs)',
        'Memoria RAM',
        'Discos duros (HDD) y SSD',
        'Tarjetas gráficas (GPU)',
        'Baterías y cargadores',
      ],
      //Imagen columna 3 hardware 
      img: Har,
      // Route Catalogo hardware
      route: '/catalogo/Hardware'
    },
    {
       //columna 4 Clasificación TI 
      //Titulo columna 4 Almacenamiento 
      title: 'Almacenamiento externo',
      text: [
        //Puntos columna 4 Almacenamiento 
        'Discos duros externos',
        'Memorias USB',
        'Tarjetas SD y microSD',
        'NAS (nivel usuario básico)',
        'Unidades SSD externas'
      ],
      //Imagen columna 4 Almacenamiento 
      img: Disco,
      //Route Catalogo Almacenamiento */}
      route: '/catalogo/Almacenamiento'
    },
     {
       //columna 5 Clasificación TI
      //Titulo columna 5 Redes
      title: 'Redes y Conectividad',
      text: [
        //Puntos columna 5 Redes
        'Switches, routers, firewalls',
        'Access points y redes Wi-Fi',
        'Sistemas SD-WAN y MPLS',
        'Cables, racks y conectores',
        'Fuentes de poder'
      ],
      //Imagen columna 5 Redes
      img: Redes, 
      //Route Catalogo Redes
      route: '/catalogo/Redes'
    },
    {
       //columna 6 Clasificación TI 
      //Titulo columna 6 Suministros
      title: 'Sunimistros',
      text: [
        //Puntos columna 6 Suministros 
        'Tonner',
        'Etiquetas',
        'Empaque y Embalaje',
        'Canaletas',
        'Cintas'
      ],
      //Imagen columna 6 Suministros
      img: Tonner,
      //Route Catalogo Suministros
      route: '/catalogo/Suministros'
    }
  ].map((item, i) => (
    <div className="tarjeta-infra" key={i}>
      <img src={item.img} alt={item.title} className="img-tarjeta-infra" />
      <h3>{item.title}</h3>
      <ul>
        {item.text.map((punto, j) => (
          <li key={j}>• {punto}</li>
        ))}
      </ul>
      <Link
        to={item.route}
        className="btn-whatsapp"
      >
        Ver catálogo
      </Link>
    </div>
  ))}
</div>








      {/*Bloque carrusel */}
      <div className="logo-carousel-container">
        {/* Titulo bloque carrusel*/}
        <h2 className="titulo-carousel" color='black'>Nuestras Alianzas</h2>
       < div className="logo-carousel-inner">
       {/* Imagenes bloque carrusel*/}
        <div className="logo-carousel-track">
          <img src={IM1} alt="IM1" />
          <img src={IM2} alt="IM2" />
          <img src={IM3} alt="IM3" />
          <img src={IM4} alt="IM4" />
          <img src={IM5} alt="IM5" />
          <img src={IM6} alt="IM6" />
          <img src={IM7} alt="IM7" />
          <img src={IM8} alt="IM8" />
          <img src={IM9} alt="IM9" />
          <img src={IM10} alt="IM10" />
          <img src={IM11} alt="IM11" />
          <img src={IM12} alt="IM12" />
          <img src={IM13} alt="IM13" />
          <img src={IM14} alt="IM14" />
          <img src={IM15} alt="IM15" />
          <img src={IM16} alt="IM16" />
          <img src={IM17} alt="IM17" />
          <img src={IM18} alt="IM18" />
          <img src={IM19} alt="IM19" />
          <img src={IM20} alt="IM20" />
          <img src={IM21} alt="IM21" />
          <img src={IM22} alt="IM22" />
          <img src={IM23} alt="IM23" />
          <img src={IM24} alt="IM24" />
          <img src={IM25} alt="IM25" />
          <img src={IM26} alt="IM26" />
          <img src={IM27} alt="IM27" />
          <img src={IM28} alt="IM28" />
          <img src={IM29} alt="IM29" />
          <img src={IM30} alt="IM30" />
          <img src={IM32} alt="IM32" />
          <img src={IM33} alt="IM33" />
          <img src={IM34} alt="IM34" />
          <img src={IM35} alt="IM35" />
          <img src={IM36} alt="IM36" />
          {/* Repite para efecto de bucle infinito */}
           {/* 👇 Duplicado para el efecto infinito */}
    <img src={IM1} alt="IM1" />
    <img src={IM2} alt="IM2" />
    <img src={IM3} alt="IM3" />
    <img src={IM4} alt="IM4" />
    <img src={IM5} alt="IM5" />
    <img src={IM6} alt="IM6" />
    <img src={IM7} alt="IM7" />
    <img src={IM8} alt="IM8" />
    <img src={IM9} alt="IM9" />
    <img src={IM10} alt="IM10" />
          <img src={IM11} alt="IM11" />
          <img src={IM12} alt="IM12" />
          <img src={IM13} alt="IM13" />
          <img src={IM14} alt="IM14" />
          <img src={IM15} alt="IM15" />
          <img src={IM16} alt="IM16" />
          <img src={IM17} alt="IM17" />
          <img src={IM18} alt="IM18" />
          <img src={IM19} alt="IM19" />
          <img src={IM20} alt="IM20" />
          <img src={IM21} alt="IM21" />
          <img src={IM22} alt="IM22" />
          <img src={IM23} alt="IM23" />
          <img src={IM24} alt="IM24" />
          <img src={IM25} alt="IM25" />
          <img src={IM26} alt="IM26" />
          <img src={IM27} alt="IM27" />
          <img src={IM28} alt="IM28" />
          <img src={IM29} alt="IM29" />
          <img src={IM30} alt="IM30" />
          <img src={IM32} alt="IM32" />
          <img src={IM33} alt="IM33" />
          <img src={IM34} alt="IM34" />
          <img src={IM35} alt="IM35" />
          <img src={IM36} alt="IM36" />
        </div>
      </div>
      </div>

{/* Contenedor principal del formulario de contacto*/}
 <div className="formulario-imagen-style20">
  <div className="linea-superior20"></div>

  {/*Titulo Formulario*/}
  <h2>
  {!enviado ? (
    'Contáctanos para más información'
  ) : (
    <>
    {/* Titulo al enviar*/}
      ¡¡¡ GRACIAS POR CONTACTARNOS !!!<br />
        Un especialista se pondrá en contacto contigo.
    </>
  )}
</h2>

  {!enviado ? (
    <form
      onSubmit={handleSubmit}
      action="https://formsubmit.co/ivan.benitez@iatekza.com"
      method="POST"
      className="formulario-simple20"
    >
      <input type="hidden" name="_captcha" value="false" />
{/* Campos de entrada para nombre, teléfono, correo, empresa y mensaje */}

      {/* Campo nombre*/}
      <input type="text" name="nombre" placeholder="Nombre" required />
      {/* Campo  Numero Telefonico*/}
      <input type="tel" name="numero" placeholder="Número Telefónico" required />
      {/* Campo Correo Electronico*/}
      <input type="email" name="correo" placeholder="Correo Electrónico" required />
      {/* Campo Empresa*/}
      <input type="text" name="empresa" placeholder="Empresa (Opcional)" />
      {/* Campo Mensaje*/}
      <textarea name="mensaje" placeholder="Mensaje" required></textarea>
      {/* Botón de envío del formulario */}
      <button type="submit">Enviar</button>
    </form>
  ) : (
    <div className="confirmacion-envio20">
      {/* gift al enviar formulario */}
      <img src={checkAnim} alt="Éxito" />
      {/* Texto abajo al enviar*/}
      <p>¡ Mensaje enviado correctamente !</p>
    </div>
  )}
</div>



{/* Contenedor principal  de pie de página con contacto*/}
<div className="contacto-footer-nuevo">
  <div className="footer-contenido-nuevo">
    {/* Fondo completo con redes */}
  <img src={RedesFondo} alt="Fondo redes" className="redes-fondo-completa" />
    {/* Columna 1: Contacto */}
    <div className="footer-columna-nueva">
  <h4>CONTACTO GRUPO IATEKZA</h4>
{/* Ubicación contacto*/}
  <div className="footer-item">
    <img src={Ubi} alt="Ubi" className="footer-icono" />
    <p>Circon 5, Colonia El Pedregal de <br /> Atizapán, Estado de México, C.P. 52948.</p>
  </div>
{/* Numero contacto*/}
  <div className="footer-item">
    <img src={Telefono} alt="Teléfono" className="footer-icono" />
    <p>+52 55 5335 5810</p>
  </div>
{/* Correo contacto*/}
  <div className="footer-item">
    <img src={Email34} alt="Correo" className="footer-icono" />
    <p>ventas@iatekza.com</p>
  </div>
</div>


    {/* Columna 2: Servicios */}
    <div className="footer-columna-nueva">
      <h4>Conoce nuestros servicios</h4>
      <ul>
        {/* IAutomatiza CFDI Colum 3*/}
        
        <li><a href="/">• IAutomatizacion CFDI</a></li>
         {/*Facturacion Electronica Colum 3*/}
        <li><a href="/Facturacion">• Facturación Electrónica</a></li>
        {/* Servicio Asesoría empresarial colum 2*/}
        <li><a href="/Consultoria">• Asesoría Empresarial</a></li>
        {/* Servicio Soluciones Tecnológicas colum 2*/}
        <li><a href="/Sistemas">• Soluciones Tecnologícas</a></li>
      </ul>
      {/*Facebook Colum 2*/}
      <div className="iconos-redes-nuevos">
        <a href="https://www.facebook.com/profile.php?id=61577085653032&locale=es_LA/" target="_blank" rel="noopener noreferrer">
          <img src={Facebok} alt="Facebook" />
        </a>
        {/*Wasak Colum 2*/}
        <a href="https://api.whatsapp.com/send?phone=5215567786252&text=Hola, me gustaría más información acerca de:" target="_blank" rel="noopener noreferrer">
          <img src={Wasa} alt="WhatsApp" />
        </a>
        {/*Instagram Colum 2*/}
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">
          <img src={insta} alt="Instagram" />
        </a>
      </div>
    </div>

    {/* Columna 3: Información general */}
    <div className="footer-columna-nueva">
      <h4>Información General</h4>
      <ul>
         {/*Sobre Nosotros Colum 3*/}
        <li><a href="/Nosotros">Sobre nosotros</a></li>
         {/*Casos de Exito Colum 3*/}
        <li><a href="/CasosExito">Casos de Éxito</a></li>
         
        {/*Aviso Legal Colum 3*/}
        <li><a href="/Legal">Aviso Legal</a></li>
      </ul>
    </div>
  </div>

{/*Línea de derechos reservados */}
  <div className="footer-bottom-nuevo">
    <p>© Grupo IAtekza 2025 – Todos los derechos reservados</p>
  </div>
</div>
    </>
  );
}

export default Comercializacion;
